import React, {useState, useEffect} from 'react';
import {runQuery} from '../utils'
import {getExpressionTypeInfo} from './queries'
import {TextOutlineWrapper} from "../TextOutlineWrapper/TextOutlineWrapper"

interface MyComponentProps {
  expressionTypeId: string
  handleChangeInfo?: any,
}

export const ExpressionType: React.FC<MyComponentProps> = (props) => {
  const [expressions, setExpressions] = useState<any[]>([])
  useEffect(()=> {
    const results = runQuery(getExpressionTypeInfo(props.expressionTypeId))
    results.then((d) => {
      const bindings = d.data.results.bindings
      setExpressions(bindings)
    })
  }, [props.expressionTypeId])
  return (
    <div>
      <h1>{props.expressionTypeId}</h1>
      {expressions.map((e)=> {
        return (
          <div>
          <TextOutlineWrapper
          focusResourceid={e.expression.value}
          resourceid={e.expression.value}
          title={e.authorTitle ? e.authorTitle.value + ", " + e.eLongTitle.value : e.eLongTitle.value }
          hidden={false}
          mtFocus={""}
          collectionLink={true}
          showParentLink={true}
          handleChangeInfo={props.handleChangeInfo}
          />
          </div>
        )
      })}
      
      
  </div>

  );
}
